import React from "react"
import { Link } from "react-router-dom"
import { Autoplay } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react" // basic
import "swiper/css" //basic

// map함수
import NewsData from "../../data/News-Data";

import ScrollPosition from "../../hook/ScrollPosition"




const AboutNews = () => {
   const posts = NewsData;
   const scrollPosition = ScrollPosition()
   return (
      <div className='AboutNews'>
         <div className='inner'>
            <h1>NEWS</h1>
            <Link to='/NEWS'><h3>더보기</h3></Link>
            <div className='NewsBox'>
               <div className={`Pop-text ${scrollPosition >= 2100 ? 'originPosition' : ''}`}>
                  <Link to="/News"><div className="BoxCover flexCenter">자세히보기</div></Link>
                  <span className={`G ${scrollPosition >= 2200 ? 'originVisible' : ''}`}>G</span>
                  <span className={`R ${scrollPosition >= 2300 ? 'originVisible' : ''}`}>R</span>
                  <span className={`A ${scrollPosition >= 2400 ? 'originVisible' : ''}`}>A</span>
                  <span className={`N1 ${scrollPosition >= 2500 ? 'originVisible' : ''}`}>N</span>
                  <span className={`D ${scrollPosition >= 2550 ? 'originVisible' : ''}`}>D</span>

                  <span className={`O ${scrollPosition >= 2600 ? 'originVisible' : ''}`}>O</span>
                  <span className={`P ${scrollPosition >= 2650 ? 'originVisible' : ''}`}>P</span>
                  <span className={`E ${scrollPosition >= 2700 ? 'originVisible' : ''}`}>E</span>
                  <span className={`N2 ${scrollPosition >= 2750 ? 'originVisible' : ''}`}>N</span>
               </div>

               <Swiper className={`swiper-box ${scrollPosition >= 2300 ? 'originPosition' : ''}`}
                  modules={[Autoplay]} spaceBetween={20} slidesPerView={3}
                  autoplay={{delay: 2500, disableOnInteraction: true,}}
                  loop={true}
                  breakpoints={{ // 반응형 설정
                     768: {
                        slidesPerView: 3,
                     },
                  }}
               >
                  <SwiperSlide className='slide'>
                     <img src={require("../../img/news/news02.jpg")} alt='' />
                     <div className="BoxCover flexCenter">{posts[0].title}</div>
                  </SwiperSlide>
                  <SwiperSlide className='slide'>
                     <img src={require("../../img/news/news03.jpg")} alt='' />
                     <div className="BoxCover flexCenter">{posts[1].title}</div>
                  </SwiperSlide>
                  <SwiperSlide className='slide'>
                     <img src={require("../../img/news/news04.jpg")} alt='' />
                     <div className="BoxCover flexCenter">{posts[2].title}</div>
                  </SwiperSlide>
                  <SwiperSlide className='slide'>
                     <img src={require("../../img/news/news05.jpg")} alt='' />
                     <div className="BoxCover flexCenter">{posts[3].title}</div>
                  </SwiperSlide>
                  <SwiperSlide className='slide'>
                     <img src={require("../../img/news/news06.jpg")} alt='' />
                     <div className="BoxCover flexCenter">{posts[4].title}</div>
                  </SwiperSlide>
                  <SwiperSlide className='slide'>
                     <img src={require("../../img/news/news07.jpg")} alt='' />
                     <div className="BoxCover flexCenter">{posts[5].title}</div>
                  </SwiperSlide>
               </Swiper>
            </div>
         </div>
      </div>
   )
}

export default AboutNews
